import * as $ from "jquery";
import * as Swiper from 'swiper/dist/js/swiper.min';
import * as TweenLite from "gsap/TweenLite";
import "../../lib/objectFitPolyfill.min.js";

declare var objectFitPolyfill:any;

function slideChangeFunctions(element) {
		let $el = $(element);
		let actions = $el.data('slide-change');

		if (!actions) {
			return;
		}

		if (typeof(actions) === 'string') {
			actions = [{
				action: actions,
				target: $el.data('target'),
				delay: $el.data('delay') || 0
			}];
		}

		for (let i = 0; i < actions.length; i++) {
			let nextSequence = actions[i];
			let nextAction = nextSequence.action;
			let $nextTarget = $el.find(nextSequence.target) || $el;
			let delay = nextSequence.delay || 0;

			switch (nextAction) {
				case 'applyClass':
				case 'apply-class':
					TweenLite.delayedCall(delay, function () {
						let scrollClass = nextSequence.class;
						$nextTarget.addClass(scrollClass);
					});
					break;
				case 'removeClass':
				case 'remove-class':
					TweenLite.delayedCall(delay, function () {
						let scrollClass = nextSequence.class;
						$nextTarget.removeClass(scrollClass);
					});
					break;
			}
		}
}

function initBackgroundRotator(){
	//Preload our faucet images so they pop in nice and fast when we transition
	let preloadImgs = [];
	$('.background-rotator__list-item').each(function() {
		let img = new Image();
		img.src = $(this).data("img");
		if(img.src) {
			preloadImgs.push(img);
		}
	});

	$('.js-background-rotator').each(function(index){

		let $this = $(this);

		$this.addClass('background-rotator-'+index);

		//create blank object to push data to
		let sliderList = [];

		//setup each swiper instances
		let swiper = new Swiper('.background-rotator-'+index,{
			slidesPerView: 1,
			init: false,
			loop: true,
			speed: 600,
			//simulateTouch: false,
			preventInteractionOnTransition: true,

			// Navigation arrows
			navigation: {
				nextEl: $this.closest('.background-rotator').find('.swiper-button-next')[0],
				prevEl: $this.closest('.background-rotator').find('.swiper-button-prev')[0],
			}
		});

		//push up the swiper data
		sliderList.push(swiper);


		swiper.on('init', function(){
			slideChangeFunctions(this.$el[0]);
			let $swiperParent = $(swiper.el).parents('.background-rotator');
			let activeImageSrc = $(swiper.slides[swiper.activeIndex]).attr('data-img');
			let activeImageAlt = $(swiper.slides[swiper.activeIndex]).attr('data-alt');
			$swiperParent.find('.js-bg-img').attr({'src': activeImageSrc, 'alt' : activeImageAlt});
			setTimeout(function(){
				objectFitPolyfill();
			},100)
		});

		//transition start functions
		swiper.on('transitionStart', function(){
			let $swiperParent = $(swiper.el).parents('.background-rotator');
			let activeImageSrc = $(swiper.slides[swiper.activeIndex]).attr('data-img');
			let activeImageAlt = $(swiper.slides[swiper.activeIndex]).attr('data-alt');
			let $bgImg = $swiperParent.find('.js-bg-img');


			$bgImg.clone().removeClass('js-bg-img').addClass('background-rotator__bg-cloned js-cloned-img').insertBefore( $bgImg );
			$swiperParent.find('.js-cloned-img').attr({'src': activeImageSrc, 'alt': activeImageAlt});
			$bgImg.addClass('state-fading');
		});

		swiper.on('transitionEnd', function(){
			let $swiperParent = $(swiper.el).parents('.background-rotator');
			$swiperParent.find('.state-fading').remove();
			$swiperParent.find('.js-cloned-img').removeClass('background-rotator__bg-cloned js-cloned-img').addClass('js-bg-img');

			setTimeout(function() {
				slideChangeFunctions($swiperParent);
			}, 250);
		});

		swiper.init();
	});
}

export function init() {
	initBackgroundRotator();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/backgroundRotator.ts